import { Observable, Subject } from 'rxjs';

/**
 * A class that encloses the functionality for the badge system.
 * The use of observer and observable for auto-updating & manually updating the badge.
 * The default refresh rate is 10 min.
 */
export class Badge {
	private request: Observable<number>;
	private subject: Subject<number>;

	constructor(_request: Observable<number>, _refreshRate: number = 60000 * 10) {
		this.request = _request;
		this.subject = new Subject();
		this.updateBadge();
		setInterval(() => this.updateBadge(), _refreshRate);
	}

	/**
	 * Update the the badge using the request that is passed through
	 * during the initialize (construct) of a Badge
	 *
	 * Emits the actual count using the observer on which the subscribe is set
	 */
	public updateBadge(): void {
		this.request?.subscribe(
			(data) => {
				this.subject.next(data);
			},
			() => {}
		);
	}

	/**
	 * A get method to get the observable that returns the accurate count
	 * update badge is called again tp make sure it is properly initialized
	 * @returns The observable
	 */
	public getObservable(): Subject<number> {
		this.updateBadge();
		return this.subject;
	}

	/**
	 * Destroy the observable & observer
	 */
	public destroy(): void {
		this.request = null;
		this.subject.complete();
		setTimeout(() => {
			this.subject = null;
		}, 100);
	}
}
